import { inject, Injectable } from "@angular/core";
import { TemplateService } from "@domain/project/template/template.service";
import { BusinessScope } from "@lib/constants/business-scope";
import { map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ProjectStatusService {
  private templateService: TemplateService = inject(TemplateService);

  getProjectStatuses(scope: BusinessScope) {
    return this.templateService.getGlobalTemplate(scope).pipe(
      map((template) => {
        const statuses = template!.properties!.project!.details!.information!.statuses ?? [];
        return statuses.map((status) => ({ ...status, scope }));
      }),
    );
  }

  translate(text: string, scope: string) {
    const FGDS_STATUS: Record<string, string> = {
      Active: $localize`:@@fgds.projectStatus.active:Active`,
      Quoted: $localize`:@@fgds.projectStatus.quoted:Quoted`,
      Cancelled: $localize`:@@fgds.projectStatus.cancelled:Closed (cancelled)`,
      Completed: $localize`:@@fgds.projectStatus.completed:Closed (completed)`,
      "Only for Testing": $localize`:@@fgds.projectStatus.testing:Only for Testing`,
    };

    const MONITORING_STATUS: Record<string, string> = {
      New: $localize`:@@monitoring.projectStatus.new:New`,
      "In Progress": $localize`:@@monitoring.projectStatus.progress:In Progress`,
      Quoting: $localize`:@@monitoring.projectStatus.quoting:Quoting`,
      Completed: $localize`:@@monitoring.projectStatus.cancelled:Cancelled`,
      Cancelled: $localize`:@@monitoring.projectStatus.completed:Completed`,
      "Only for Testing": $localize`:@@monitoring.projectStatus.testing:Only for Testing`,
    };

    if (scope === BusinessScope.FGDS && FGDS_STATUS[text]) {
      return FGDS_STATUS[text];
    }

    if (scope === BusinessScope.MONITORING && MONITORING_STATUS[text]) {
      return MONITORING_STATUS[text];
    }
    return $localize`:@@projectStatus.unknown:Unknown`;
  }
}
